import { toast } from 'sonner';
export const phantomConnection = async (wallet) => {
    try {
        const phantom = wallet.wallets.find((w) => w.adapter.name === 'Phantom');

        if (!phantom || !phantom.adapter) {
            toast.error('Phantom wallet not found');
            return 'chainerror';
        }

        // Select Phantom wallet if not already selected
        if (phantom.adapter?.name !== 'Phantom') {
            await wallet.select(phantom.adapter.name);
        }

        // Disconnect if already connected
        if (phantom.adapter.connected) {
            await phantom.adapter.disconnect();
        }

        // Now connect to Phantom
        await phantom.adapter.connect();

        const publicKey = phantom.adapter.publicKey;
        if (!publicKey) {
            toast.error('Failed to get Phantom wallet address');
            return 'chainerror';
        }

        const newWallet = publicKey.toBase58();

        return newWallet;
    } catch (error) {
        toast.error('Error connecting to Phantom wallet');
        return 'chainerror';
    }
};
